export function checkoutKey(keys, priceId) {
  if (!keys.has(priceId)) keys.set(priceId, globalThis.crypto.randomUUID())

  return keys.get(priceId)
}

export function checkoutErrorMessage(error) {
  if (error?.status === 403)
    return 'Unable to start checkout from this page. Reload and try again.'
  if (error?.status === 404)
    return 'That billing choice is no longer available.'
  if (error?.status === 429)
    return 'Too many checkout attempts. Try again later.'
  if (error?.status === 502)
    return 'Unable to start checkout. You can retry this checkout attempt.'
  if (
    error?.status === 409 &&
    error.message === 'Billing price is unavailable'
  ) {
    return 'This price is temporarily unavailable.'
  }
  if (
    error?.status === 409 &&
    error.message === 'Account already has a subscription'
  ) {
    return 'This account already has a current subscription.'
  }
  if (error?.status === 409)
    return 'Checkout could not be started because billing details changed.'

  return 'Unable to start checkout. Refresh billing details before trying again.'
}
